var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { weekDayMonthDay } from '../../constants/dateStrings';
import { dateFormat } from '../../components/order-details/util/format';
import { getOrderStatus } from '../../components/order-details/util/FulfillmentStatus';
import { STATUS_CODE } from '../../constants/status';
export var getQuantityByStatus = function (_a, fulfillmentType) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var cancelledQuantity = _a.cancelledQuantity, currentQuantity = _a.currentQuantity, originalOrderedQuantity = _a.originalOrderedQuantity, orginalOrderedQuantity = _a.orginalOrderedQuantity, quantity = _a.quantity, returnedQuantity = _a.returnedQuantity, statusCode = _a.statusCode, workOrderFulfilledQty = _a.workOrderFulfilledQty, qtyToPrint = _a.qtyToPrint;
    if (fulfillmentType === void 0) { fulfillmentType = ''; }
    if (statusCode === STATUS_CODE.CANCELED) {
        return cancelledQuantity !== null && cancelledQuantity !== void 0 ? cancelledQuantity : 0;
    }
    if (statusCode === STATUS_CODE.RETURNED) {
        return returnedQuantity !== null && returnedQuantity !== void 0 ? returnedQuantity : 0;
    }
    if (fulfillmentType === 'InStorePurchase') {
        return (_c = (_b = quantity !== null && quantity !== void 0 ? quantity : originalOrderedQuantity) !== null && _b !== void 0 ? _b : orginalOrderedQuantity) !== null && _c !== void 0 ? _c : 0;
    }
    // currently workOrderFulfilledQty does not update for partial returns, so we need to check if it is different from currentQuantity
    if (workOrderFulfilledQty && currentQuantity !== workOrderFulfilledQty) {
        return ((_f = (_e = (_d = currentQuantity !== null && currentQuantity !== void 0 ? currentQuantity : quantity) !== null && _d !== void 0 ? _d : originalOrderedQuantity) !== null && _e !== void 0 ? _e : orginalOrderedQuantity) !== null && _f !== void 0 ? _f : 0);
    }
    return ((_l = (_k = (_j = (_h = (_g = workOrderFulfilledQty !== null && workOrderFulfilledQty !== void 0 ? workOrderFulfilledQty : currentQuantity) !== null && _g !== void 0 ? _g : quantity) !== null && _h !== void 0 ? _h : originalOrderedQuantity) !== null && _j !== void 0 ? _j : orginalOrderedQuantity) !== null && _k !== void 0 ? _k : qtyToPrint) !== null && _l !== void 0 ? _l : 0);
};
var getSimplifiedDate = function (date, isReturnInitiated) {
    if (!date)
        return '';
    var dateValue = new Date("".concat(date, "T00:00:00Z"));
    var options = {};
    if (isReturnInitiated)
        options.weekday = 'short';
    else
        options.year = 'numeric';
    var simplifiedDate = dateValue.toLocaleDateString('en-US', __assign({ timeZone: 'UTC', month: 'long', day: 'numeric' }, options));
    return simplifiedDate;
};
var isWindowExpired = function (windowEndDate) { return windowEndDate === 'EXPIRED'; };
/**
 * Assumptions:
 * - A return window expires when return window end date is not defined and OMS eligibility is false
 * - returnWindowEndDate
 *    - ex: "01-01-2024" -> if we have return window days
 *    - "EXPIRED" -> return window has expired
 *    - "NOT RETURNABLE" -> item was never eligible for return
 * -  returnByDate
 *    - ex: "01-01-2024" -> if we have return window days
 *    - "EXPIRED" -> return window has expired
 */
export var getItemReturnWindow = function (deliveryStatusCode, returnWindowEndDate, returnByDate, returnTrackingList, isSoris) {
    if (deliveryStatusCode === void 0) { deliveryStatusCode = -1; }
    if (isSoris)
        return '';
    var orderStatus = getOrderStatus(deliveryStatusCode);
    // If item has not been delivered or is not already a return in progress, we dont display a return window
    if (!(orderStatus.isStatusDeliveredOrOrderPickedup ||
        orderStatus.isReturnStarted)) {
        return '';
    }
    // Rest of the flow will only cover delivered and return in progress items
    // General Cases
    if (returnWindowEndDate === undefined || returnWindowEndDate === null) {
        return '';
    }
    if (returnWindowEndDate === 'NOT RETURNABLE') {
        // This can be due to OMS ineliglble items or a problem retrieving the return window
        return "Item can't be returned";
    }
    if (isWindowExpired(returnWindowEndDate) && isWindowExpired(returnByDate)) {
        // Return period ended if both windows have expired
        return 'Return period has ended';
    }
    // Delivered/Picked Up Items
    if (orderStatus.isStatusDeliveredOrOrderPickedup) {
        if (isWindowExpired(returnWindowEndDate)) {
            return 'Return period has ended';
        }
        // If return window is defined then return window is shown, returnWindowEndDate should always be defined
        var simplifiedWindowEndDate_1 = getSimplifiedDate(returnWindowEndDate, false);
        return "Return by ".concat(simplifiedWindowEndDate_1);
    }
    // Return Initiated Items
    var isUpsReturn = returnTrackingList === null || returnTrackingList === void 0 ? void 0 : returnTrackingList.every(function (tracking) {
        return tracking.TrackingNumber.startsWith('1Z');
    });
    if (returnByDate && returnByDate !== 'EXPIRED') {
        if (isUpsReturn) {
            return "Return to UPS by ".concat(dateFormat(returnByDate, weekDayMonthDay));
        }
        return "Return by ".concat(dateFormat(returnByDate, weekDayMonthDay));
    }
    // This should not happen
    if (isWindowExpired(returnWindowEndDate)) {
        return '';
    }
    // return default message if returnByDate has expired
    var simplifiedWindowEndDate = getSimplifiedDate(returnWindowEndDate, false);
    return "Return by ".concat(simplifiedWindowEndDate);
};
export var checkSingleItemProtectionPlanReturn = function (orderDetailsData) {
    var _a;
    var isReturned = false;
    var amountOfItems = (_a = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.fulfillmentGroups) === null || _a === void 0 ? void 0 : _a.reduce(function (total, fg) {
        var _a;
        if (fg.returnShipments) {
            isReturned = true;
        }
        var amount = ((_a = fg.lineItems) === null || _a === void 0 ? void 0 : _a.reduce(function (fgTotal, item) {
            var _a;
            if ((item === null || item === void 0 ? void 0 : item.productType) === 'EPP')
                return fgTotal;
            return (fgTotal +
                ((_a = item === null || item === void 0 ? void 0 : item.originalOrderedQuantity) !== null && _a !== void 0 ? _a : ((item === null || item === void 0 ? void 0 : item.orginalOrderedQuantity) || 0)));
        }, 0)) || 0;
        return total + amount;
    }, 0);
    return amountOfItems === 1 && isReturned;
};
var CACHE_TTL_MS = 10 * 60 * 1000; // 10 minutes
var cache = {};
/**
 * Get cached cities for a ZIP code, respecting TTL.
 * @param zip - ZIP code string
 * @returns Array of city/state objects or empty array
 */
export var getCitiesByZip = function (zip) {
    var entry = cache[zip];
    if (!entry)
        return [];
    var now = Date.now();
    if (now - entry.timestamp > CACHE_TTL_MS) {
        delete cache[zip];
        return [];
    }
    return entry.cities;
};
/**
 * Set cities for a ZIP code in cache, with timestamp.
 * @param zip - ZIP code string
 * @param cities - Array of city/state objects
 */
export var setCitiesByZip = function (zip, cities) {
    if (zip && Array.isArray(cities)) {
        cache[zip] = {
            cities: cities,
            timestamp: Date.now(),
        };
    }
};
